<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('editCategory') }}</h2>
    <FormCategory :baseCategory="category" @submit-requested="submitRequested"></FormCategory>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import FormCategory from '../forms/FormCategory.vue'
import router from '@/router';

  
  export default {  
    data () {
    return {
      category: null
    }
    
  },
  components: { FormCategory },
  computed:{
    ...mapState('categories', ['categoryOutput']),
  },
  methods: {
    ...mapActions('categories', ['editCategory']),
    ...mapActions('categories', ['getList']),
    submitRequested (category) {
      this.editCategory(category);
    },
  },
  mounted: function()
  {
    if(!this.$route.params.category)
    {
      router.push({ path: '/categories/list' });
    }
    else
    {
      this.category = this.$route.params.category;
    }
  }
}
</script> 
 
<style scoped>
</style> 